(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cultures-discovery"] && !Shopify.designMode) return;
  try {
    
  function initCultureDiscovery(root){
    if(root.dataset.enhanced) return;
    const tabs=Array.from(root.querySelectorAll('[data-culture-tab]'));
    const panels=Array.from(root.querySelectorAll('[data-culture-panel]'));
    if(!tabs.length || !panels.length) return;
    root.dataset.enhanced='true';
    function select(tab,focus){
      const key=tab.dataset.cultureTab;
      tabs.forEach(item=>{const active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;});
      panels.forEach(panel=>panel.classList.toggle('is-active',panel.dataset.culturePanel===key));
      if(focus) tab.focus();
    }
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>select(tab,false));
      tab.addEventListener('keydown',event=>{
        let next=index;
        if(event.key==='ArrowRight') next=(index+1)%tabs.length;
        else if(event.key==='ArrowLeft') next=(index-1+tabs.length)%tabs.length;
        else if(event.key==='Home') next=0;
        else if(event.key==='End') next=tabs.length-1;
        else return;
        event.preventDefault();select(tabs[next],true);
      });
    });
  }
  document.querySelectorAll('[data-cultures-discovery]').forEach(initCultureDiscovery);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cultures-discovery]').forEach(initCultureDiscovery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-ideas"] && !Shopify.designMode) return;
  try {
    
function setupIdeas(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('form');
  const collection = root.querySelector('[data-ideas-collection]');
  if (!form || !collection) return;
  const subject = root.querySelector('[data-ideas-subject]');
  const music = root.querySelector('[data-ideas-music]');
  const artist = root.querySelector('[data-ideas-artist]');
  const album = root.querySelector('[data-ideas-album]');
  const sync = () => {
    const isMusic = collection.selectedOptions[0]?.dataset.music === 'true';
    const showMusic = isMusic;
    root.querySelector('[data-ideas-type]').value = isMusic ? 'Demande détaillée' : 'Suggestion rapide';
    music.hidden = !showMusic;
    root.querySelector('[data-ideas-quick]').hidden = showMusic;
    subject.disabled = showMusic;
    subject.required = !showMusic;
    [artist, album].forEach(input => {input.disabled = !showMusic; input.required = showMusic;});
  };
  form.addEventListener('change', sync);
  form.addEventListener('submit', () => {
    const body = form.querySelector('textarea');
    if (!body.value.trim()) body.value = artist.disabled ? subject.value.trim() : artist.value.trim() + ' — ' + album.value.trim();
  });
  sync();
}
document.querySelectorAll('[data-ideas]').forEach(setupIdeas);
document.addEventListener('shopify:section:load', event => {event.target.querySelectorAll('[data-ideas]').forEach(setupIdeas);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-lewis-microsite"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var replay = event.target.closest('[data-micro-replay]');
    if (!replay) return;
    var root = replay.closest('[data-cltrs-micro]');
    if (!root) return;
    root.classList.remove('is-entering');
    void root.offsetWidth;
    root.classList.add('is-entering');
    root.querySelector('.cltrs-micro__entry').style.animation = 'none';
    root.querySelector('.cltrs-micro__shell').style.animation = 'none';
    void root.offsetWidth;
    root.querySelector('.cltrs-micro__entry').style.animation = '';
    root.querySelector('.cltrs-micro__shell').style.animation = '';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-music-nfc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-music-scan]');
    if (!trigger) return;
    var root = trigger.closest('[data-music-demo]');
    if (!root) return;
    window.clearTimeout(root.musicTimer);
    root.classList.remove('is-open', 'is-scanning');
    var sheet = root.querySelector('.cltrs-music__sheet');
    sheet.setAttribute('aria-hidden', 'true');
    sheet.inert = true;
    root.querySelectorAll('[data-music-scan]').forEach(function(button) { button.setAttribute('aria-expanded', 'false'); });
    void root.offsetWidth;
    root.classList.add('is-scanning');
    root.querySelector('[data-music-status]').textContent = 'Cadre détecté. Ouverture du lien de l’album…';
    var delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 550;
    root.musicTimer = window.setTimeout(function() {
      root.classList.remove('is-scanning');
      root.classList.add('is-open');
      sheet.removeAttribute('inert');
      sheet.setAttribute('aria-hidden', 'false');
      root.querySelectorAll('[data-music-scan]').forEach(function(button) { button.setAttribute('aria-expanded', 'true'); });
      root.querySelector('[data-music-status]').textContent = 'Album ouvert. Le bouton Apple Music permet de l’écouter.';
    }, delay);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-nfc-album"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = 'cltrs-album-demo-v1';
    const tokens = ['test-lewis-001', 'test-sport-002', 'test-sport-003'];
    const prizes = [
      { ceiling: 70, label: 'Badge numérique exclusif (simulation)' },
      { ceiling: 95, label: 'Réduction de 5 € (simulation, aucun code créé)' },
      { ceiling: 99, label: 'Réduction de 10 € (simulation, aucun code créé)' },
      { ceiling: 100, label: 'Livraison offerte (simulation, aucun code créé)' }
    ];
    const safeRead = () => {
      try {
        const saved = JSON.parse(localStorage.getItem(key) || '{}');
        return saved && typeof saved === 'object' && saved.claims && typeof saved.claims === 'object' ? saved : { claims: {} };
      } catch { return { claims: {} }; }
    };
    const save = (state) => { try { localStorage.setItem(key, JSON.stringify(state)); } catch {} };
    const render = (root, state) => {
      const count = tokens.filter(token => state.claims[token]).length;
      root.querySelector('[data-album-progress]').textContent = `${count} / ${tokens.length}`;
      root.querySelector('[data-album-bar]').style.width = `${count / tokens.length * 100}%`;
      for (const button of root.querySelectorAll('[data-album-token]')) {
        const claimed = Boolean(state.claims[button.dataset.albumToken]);
        button.disabled = claimed;
        button.textContent = claimed ? 'Découvert ✓' : 'Simuler le scan';
      }
    };
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-album-token], [data-album-reset]');
      if (!button) return;
      const root = button.closest('[data-album-demo]');
      if (!root) return;
      const result = root.querySelector('[data-album-result]');
      if (button.hasAttribute('data-album-reset')) {
        const state = { claims: {} };
        save(state);
        render(root, state);
        result.textContent = 'Test réinitialisé. Aucun vrai cadeau n’a été créé.';
        return;
      }
      const token = button.dataset.albumToken;
      if (!tokens.includes(token)) return;
      const state = safeRead();
      if (state.claims[token]) {
        result.textContent = 'Cette puce fictive a déjà été utilisée sur cet appareil.';
        return;
      }
      if (!globalThis.crypto?.getRandomValues) {
        result.textContent = 'Le tirage de test est indisponible sur ce navigateur.';
        return;
      }
      const random = new Uint32Array(1);
      globalThis.crypto.getRandomValues(random);
      const roll = random[0] / 4294967296 * 100;
      const prize = prizes.find(item => roll < item.ceiling);
      state.claims[token] = prize.label;
      save(state);
      render(root, state);
      const complete = tokens.every(item => state.claims[item]);
      result.textContent = complete
        ? `Surprise : ${prize.label}. Catégorie Sport test complétée ! Bonus : 15 € (simulation, aucun code créé).`
        : `Surprise : ${prize.label}. Continue la collection Sport test.`;
    });
    const start = () => document.querySelectorAll('[data-album-demo]').forEach(root => render(root, safeRead()));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-nfc-pokedex"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tr = (fr, en) => document.documentElement.lang.toLowerCase().startsWith('en') ? en : fr;
    const key = 'cltrs-album-demo-v1';
    const ownedKey = 'cltrs-dex-owned-demo-v1';
    const tokens = ['test-lewis-001', 'test-sport-002', 'test-sport-003'];
    const prizes = [
      { ceiling: 70, label: tr("Badge numérique exclusif (simulation)", "Exclusive digital badge (simulation)") },
      { ceiling: 95, label: tr("Réduction de 5 € (simulation, aucun code créé)", "€5 discount (simulation, no code created)") },
      { ceiling: 99, label: tr("Réduction de 10 € (simulation, aucun code créé)", "€10 discount (simulation, no code created)") },
      { ceiling: 100, label: tr("Livraison offerte (simulation, aucun code créé)", "Free shipping (simulation, no code created)") }
    ];
    const read = () => {
      try { const saved = JSON.parse(localStorage.getItem(key) || '{}'); return saved && saved.claims && typeof saved.claims === 'object' ? saved : { claims: {} }; }
      catch { return { claims: {} }; }
    };
    const save = state => { try { localStorage.setItem(key, JSON.stringify(state)); } catch {} };
    const readOwned = () => {
      try { const saved = JSON.parse(localStorage.getItem(ownedKey) || '[]'); return new Set(Array.isArray(saved) ? saved.filter(value => typeof value === 'string') : []); }
      catch { return new Set(); }
    };
    const saveOwned = owned => { try { localStorage.setItem(ownedKey, JSON.stringify([...owned])); } catch {} };
    const renderOwned = owned => {
      document.querySelectorAll('[data-dex-card]').forEach(card => {
        const obtained = owned.has(card.dataset.dexProduct);
        card.dataset.owned = String(obtained);
        const button = card.querySelector('[data-dex-toggle]');
        button.setAttribute('aria-pressed', String(obtained));
        button.textContent = obtained ? tr("RETIRER LA SIMULATION", "REMOVE SIMULATION") : tr("SIMULER OBTENU", "SIMULATE COLLECTED");
        card.querySelector('[data-dex-seal]').textContent = obtained ? tr("OBTENU · TEST", "COLLECTED · TEST") : tr("NON DÉCOUVERT", "UNDISCOVERED");
      });
      document.querySelectorAll('.cltrs-dex__category').forEach(category => {
        const cards = [...category.querySelectorAll('[data-dex-card]')];
        const count = cards.filter(card => card.dataset.owned === 'true').length;
        const progress = category.querySelector('[data-dex-progress]');
        if (progress) progress.textContent = `${count} / ${cards.length} ${tr('cartes test obtenues', 'test cards collected')}`;
      });
    };
    const render = (root, state) => {
      const count = tokens.filter(token => state.claims[token]).length;
      root.querySelector('[data-album-progress]').textContent = `${count} / ${tokens.length}`;
      root.querySelector('[data-album-bar]').style.width = `${count / tokens.length * 100}%`;
      root.querySelectorAll('[data-album-token]').forEach(button => {
        const claimed = Boolean(state.claims[button.dataset.albumToken]);
        button.disabled = claimed;
        button.textContent = claimed ? tr("Découvert ✓", "Discovered ✓") : tr("Simuler le scan", "Simulate a scan");
      });
    };
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-dex-toggle]');
      if (!button) return;
      const card = button.closest('[data-dex-card]');
      if (!card) return;
      const owned = readOwned();
      if (owned.has(card.dataset.dexProduct)) owned.delete(card.dataset.dexProduct);
      else owned.add(card.dataset.dexProduct);
      saveOwned(owned);
      renderOwned(owned);
    });
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-album-token], [data-album-reset]');
      if (!button) return;
      const root = button.closest('[data-album-demo]');
      if (!root) return;
      const result = root.querySelector('[data-album-result]');
      if (button.hasAttribute('data-album-reset')) {
        const state = { claims: {} }; save(state); render(root, state);
        result.textContent = tr("Test réinitialisé. Aucun vrai cadeau n’a été créé.", "Test reset. No real gift was created.");
        return;
      }
      const token = button.dataset.albumToken;
      if (!tokens.includes(token)) return;
      const state = read();
      if (state.claims[token]) { result.textContent = tr("Cette puce fictive a déjà été utilisée sur cet appareil.", "This fictional chip has already been used on this device."); return; }
      if (!globalThis.crypto?.getRandomValues) { result.textContent = tr("Le tirage de test est indisponible sur ce navigateur.", "The test draw is unavailable in this browser."); return; }
      const random = new Uint32Array(1);
      globalThis.crypto.getRandomValues(random);
      const roll = random[0] / 4294967296 * 100;
      const prize = prizes.find(item => roll < item.ceiling);
      state.claims[token] = prize.label; save(state); render(root, state);
      const complete = tokens.every(item => state.claims[item]);
      result.textContent = complete
        ? `Surprise: ${prize.label}. ${tr('Catégorie Sport test complétée ! Bonus : 15 € (simulation, aucun code créé).', 'Sport test category complete! Bonus: €15 (simulation, no code created).')}`
        : `Surprise: ${prize.label}. ${tr('Continue la collection Sport test.', 'Keep collecting in the Sport test.')}`;
    });
    const start = () => {
      renderOwned(readOwned());
      document.querySelectorAll('[data-album-demo]').forEach(root => render(root, read()));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-scan-demo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var start = event.target.closest('[data-demo-start]');
    var replay = event.target.closest('[data-demo-replay]');
    if (!start && !replay) return;
    var root = event.target.closest('[data-cltrs-demo]');
    if (!root) return;
    if (root.cltrsDemoTimer) window.clearTimeout(root.cltrsDemoTimer);
    root.classList.remove('is-playing', 'is-revealed');
    root.querySelector('.cltrs-demo__result').setAttribute('aria-hidden', 'true');
    void root.offsetWidth;
    root.classList.add('is-playing');
    var status = root.querySelector('[data-demo-status]');
    if (status) status.textContent = 'Ouverture de l’expérience Lewis Hamilton…';
    var delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 100 : 1650;
    root.cltrsDemoTimer = window.setTimeout(function() {
      root.classList.remove('is-playing');
      root.classList.add('is-revealed');
      root.querySelector('.cltrs-demo__result').setAttribute('aria-hidden', 'false');
      if (status) status.textContent = 'Expérience ouverte. Utilise « Revoir l’entrée » pour relancer l’animation.';
    }, delay);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-trending"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
 const tab=event.target.closest('.cltrs-trending__tab');
 if(!tab)return;
 const root=tab.closest('.cltrs-trending');if(!root)return;
 root.querySelectorAll('.cltrs-trending__tab').forEach(function(btn){
  const active=btn===tab;
  btn.classList.toggle('is-active',active);
  btn.setAttribute('aria-selected',active?'true':'false');
 });
 root.querySelectorAll('.cltrs-trending__panel').forEach(function(panel){
  panel.hidden=panel.dataset.cltrsPanel!==tab.dataset.cltrsTab;
 });
});

const randomizeTrending = (root) => {
 root.querySelectorAll('.cltrs-trending__rail').forEach(async (rail) => {
  if (rail.dataset.randomReady) return;
  rail.dataset.randomReady = 'true';
  const candidates = new Map([...rail.children].map(card => [card.dataset.productId, card]));
  const panelId = rail.closest('[data-cltrs-panel]').dataset.cltrsPanel;
  let nextUrl = rail.dataset.nextUrl;
  const visited = new Set();
  try {
   while (nextUrl && root.isConnected && !visited.has(nextUrl)) {
    visited.add(nextUrl);
    const url = new URL(nextUrl, location.origin);
    url.searchParams.set('section_id', root.dataset.trendingSection);
    const response = await fetch(url);
    if (!response.ok) break;
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextRail = html.querySelector(`[data-cltrs-panel="${panelId}"] .cltrs-trending__rail`);
    if (!nextRail) break;
    for (const card of nextRail.children) candidates.set(card.dataset.productId, card);
    nextUrl = nextRail.dataset.nextUrl;
   }
  } catch (_) {}
  if (!root.isConnected) return;
  const cards = [...candidates.values()];
  for (let i = cards.length - 1; i > 0; i--) {
   const j = Math.floor(Math.random() * (i + 1));
   [cards[i], cards[j]] = [cards[j], cards[i]];
  }
  const selected = cards.slice(0, Number(rail.dataset.randomLimit) || 6);
  selected.forEach(card => { card.hidden = false; });
  rail.replaceChildren(...selected);
 });
};
document.querySelectorAll('[data-trending-section]').forEach(randomizeTrending);
document.addEventListener('shopify:section:load', event => {
 event.target.querySelectorAll('[data-trending-section]').forEach(randomizeTrending);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultures-wall"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = (root) => {
  if (root.dataset.wallReady) return;
  root.dataset.wallReady = 'true';
  const grid = root.querySelector('[data-wall-posters]');
  const catalog = new Map(JSON.parse(root.querySelector('[data-wall-catalog]').textContent).map(p => [String(p.id), p]));
  let previous = '';
  let busy = false;
  let timer;
  const seen = new Set();
  const shuffle = array => {
   for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
   }
   return array;
  };
  const show = async () => {
   if (busy || document.hidden || !root.isConnected) return;
   const pool = [...catalog.values()];
   if (!pool.length) return;
   busy = true;
   const count = Math.min(3, pool.length);
   const combinations = pool.length * (pool.length - 1) * (pool.length - 2) / 6;
   if (seen.size >= combinations) seen.clear();
   let chosen, key;
   for (let attempt = 0; attempt < 100; attempt++) {
    chosen = shuffle([...pool]).slice(0, count);
    key = chosen.map(p => String(p.id)).sort().join(',');
    if (key !== previous && !seen.has(key)) break;
   }
   if (key === previous && pool.length > 3) {
    const other = pool.find(p => !chosen.some(c => c.id === p.id));
    chosen[0] = other;
    key = chosen.map(p => String(p.id)).sort().join(',');
   }
   try {
    const images = await Promise.all(chosen.map(p => new Promise((resolve, reject) => {
     const img = new Image();
     img.alt = p.title;
     img.width = 750;
     img.height = 1000;
     img.onload = () => resolve(img);
     img.onerror = reject;
     img.src = p.image;
    })));
    if (!root.isConnected) return;
    const links = chosen.map((p, i) => {
     const link = document.createElement('a');
     link.className = 'cltrs-wall__frame';
     link.href = p.url;
     link.append(images[i]);
     return link;
    });
    grid.replaceChildren(...links);
    previous = key;
    seen.add(key);
   } catch (_) {
   } finally { busy = false; }
  };
  const observer = new IntersectionObserver(entries => {
   clearInterval(timer);
   if (entries[0].isIntersecting) {
    show();
    timer = setInterval(show, 2000);
   }
  });
  observer.observe(root);
  const cleanup = event => {
   if (!event.target.contains(root)) return;
   clearInterval(timer);
   observer.disconnect();
   document.removeEventListener('shopify:section:unload', cleanup);
  };
  document.addEventListener('shopify:section:unload', cleanup);
  (async () => {
   try {
    for (let page = 1; root.isConnected; page++) {
     const url = new URL(root.dataset.catalogUrl, location.origin);
     url.searchParams.set('limit', '250');
     url.searchParams.set('page', String(page));
     const response = await fetch(url);
     if (!response.ok) break;
     const { products } = await response.json();
     for (const p of products) {
      if (!p.images?.[0]?.src) continue;
      const image = new URL(p.images[0].src);
      image.searchParams.set('width', '1000');
      catalog.set(String(p.id), {id: p.id, title:p.title, url: root.dataset.catalogUrl.replace(/products.json$/, 'products/') + p.handle, image:image.href});
     }
     if (products.length < 250) break;
    }
   } catch (_) {}
  })();
 };
 document.querySelectorAll('[data-wall-root]').forEach(init);
 document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-wall-root]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
